
window.InifECMobileApp.directive('guideImagePlayer', ['$rootScope', '$ngModal', '$timeout',
	function ($rootScope, $ngModal, $timeout) {

		var _dir = {};

		var controller = ['$scope', function($scope) {

            // ===============================
            //  開啟 modal
            // ===============================
            var openModal = function() {

            	$ngModal.openModal('guide-image-player-modal');
            }

            // ===============================
            //  關閉 modal
            // ===============================
            var closeModal = function() {

            	$ngModal.closeModal('guide-image-player-modal');
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_GUIDE_IMAGE_PLAYER_MODAL', function(event, data) {
                
                $scope.showType = data && data.showType;

            	openModal();
            });

            /*==========================
                Members
            ==========================*/
            $scope.showType = 0;

            /*==========================
                Methods
            ==========================*/
            $scope.SECURE_INIFEC_URL = SECURE_INIFEC_URL;

            /*==========================
                init
            ==========================*/
            
		}]

		_dir.restrict = "E";
		_dir.scope = true;
		_dir.templateUrl = "mobile/partials/modal/guide_image_player.html";
		_dir.controller = controller;

		return _dir;
	}]
);